// Cashier Transactions Getters

export const getTransactionsList = state => {
  return state.transactionsList
}

export const getTransactionInfo = state => {
  return state.transactionInfo
}
